// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { Injectable } from '@angular/core';
import { StatePersister } from '../../services/state-persister';
import * as fromSmartResponses from './smart-responses.reducer';

@Injectable({
  providedIn: 'root'
})
export class SmartResponsesPersisterService extends StatePersister<fromSmartResponses.State> {
  constructor() {
    super(localStorage, fromSmartResponses.featureKey);
  }
}
